module.exports = __webpack_public_path__ + "static/img/博士_2022_刘美_liumei@nwafu.edu.cn.cc7cbe1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/members/博士_2022_刘美_liumei@nwafu.edu.cn.jpg
// module id = Ckez
// module chunks = 6